module.exports = __webpack_public_path__ + "img/kwaiProDownload4.8fc7fa5.png";